import React from "react";
import { CustomCodeSection as CustomCodeSectionBase } from "repoV2/components/customCode/CustomCodeSection";
import { ICustomCodeData } from "repoV2/interfaces/customCodes/ICustomCode";

export const CustomCodeSection = ({
    position,
    codes,
}: {
    position: number;
    codes: ICustomCodeData[];
}) => {
    return (
        <CustomCodeSectionBase
            position={position}
            codes={codes}
            Section={({ children }) => <section>{children}</section>}
        />
    );
};
